import { Injectable } from "@angular/core";
import { DbTableDefinition } from "src/app/_services/persistence/db-persistence/db-table-definition";

@Injectable({
  providedIn: 'root'
})
export class JobSectionDbTableDefinition extends DbTableDefinition {
    tableName = 'jobsections';
    tableStructure = `(id BIGINT(20) PRIMARY KEY null,
       label TEXT NOT NULL,
       databag LONGTEXT,
       sjobid BIGINT(20),
       sjoblabel TEXT
      );`;

      constructor() {
        super();
        // Add UpdateStatements to Map
      }
}